import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/ErrorPage.css';

const ErrorPage = () => {
  const navigate = useNavigate();

  return (
    <div className="error-container">
      <div className="error-content">
        <div className="error-header">
          <h1>Oops, something went wrong!</h1>
          <div className="error-code">404</div>
          <p className="error-message">
            Sorry, we couldn't find the page you're looking for.
          </p>
          <div className="error-details">
            <p>The page you requested might have been moved, deleted, or doesn't exist.</p>
          </div>
        </div>
        
        <button
          onClick={() => navigate('/home')}
          className="home-button"
        >
          <svg 
            className="home-icon" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" 
            />
          </svg>
          <span>Return Home</span>
        </button>
      </div>
    </div>
  );
};

export default ErrorPage;